const PASSWORD_MESSAGES = {
  uppercase: "deve conter pelo menos uma letra maiúscula",
  lowercase: "deve conter pelo menos uma letra minúscula",
  number: "deve conter pelo menos um número",
  specialCharacter:
    "deve conter pelo menos um caractere especial (ex.: !@#$%^&*)"
};

const UPPERCASE_PATTERN = /[A-Z]/;
const LOWERCASE_PATTERN = /[a-z]/;
const NUMBER_PATTERN = /[0-9]/;
const SPECIAL_CHARACTER_PATTERN = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]/;

const skipIfBlank = value => !value;

const hasUppercaseLetter = value =>
  skipIfBlank(value) || UPPERCASE_PATTERN.test(value);

const hasLowercaseLetter = value =>
  skipIfBlank(value) || LOWERCASE_PATTERN.test(value);

const hasNumber = value => skipIfBlank(value) || NUMBER_PATTERN.test(value);

const hasSpecialCharacter = value =>
  skipIfBlank(value) || SPECIAL_CHARACTER_PATTERN.test(value);

const collectPasswordErrors = (
  field,
  {
    requiredMessage = "Senha é obrigatória",
    minLengthMessage = "A senha deve conter no mínimo, 8 caracteres"
  } = {}
) => {
  const errors = [];

  if (!field.required) {
    errors.push(requiredMessage);
  } else if (!field.minLength) {
    errors.push(minLengthMessage);
  } else if (!field.hasUppercaseLetter) {
    errors.push(PASSWORD_MESSAGES.uppercase);
  } else if (!field.hasLowercaseLetter) {
    errors.push(PASSWORD_MESSAGES.lowercase);
  } else if (!field.hasNumber) {
    errors.push(PASSWORD_MESSAGES.number);
  } else if (!field.hasSpecialCharacter) {
    errors.push(PASSWORD_MESSAGES.specialCharacter);
  }

  return errors;
};

export {
  PASSWORD_MESSAGES,
  hasUppercaseLetter,
  hasLowercaseLetter,
  hasNumber,
  hasSpecialCharacter,
  collectPasswordErrors
};
